import React from 'react'
import { Link } from 'react-router-dom'
import './SharedCardContent.css'

function SharedCardContent({ icon, badgeTitle, title, text, subtext, iconClassName = '' }) {
    return (
        <div className="shared-card-section-right">
            <div className="shared-card-section-right-content">
                <div className="shared-card-section-right-icon-container">
                    <img src={icon} alt="" className={iconClassName} />
                </div>
                <div className="shared-card-section-badge">
                    {badgeTitle}
                </div>
                <h2 className="shared-card-section-title">
                    {title}
                </h2>
                <p className="shared-card-section-body">
                    {text}
                </p>
                <p className="shared-card-section-footnote">
                    {subtext}
                </p>
                <Link to="/signup" className="shared-card-section-cta button--primary-new">
                    Start saving up to 15% of billables
                </Link>
            </div>
        </div>
    )
}

export default SharedCardContent
